import React from "react";

interface SurveyStatIconWrapperProps {
    children: React.ReactNode;
}

const SurveyStatIconWrapper = ({ children }: SurveyStatIconWrapperProps) => (
    <div className="w-6 h-6 p-1 rounded-md flex items-center justify-center bg-[#F2FCFA] dark:bg-emerald-900/30">
        {children}
    </div>
);

export default SurveyStatIconWrapper;
